var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-alert',{staticClass:"refund-scenario-alert",attrs:{"active":"true","color":_vm.content.color}},[_c('div',{staticClass:"refund-scenario-alert__content"},[_c('h5',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.content.title))]),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.content.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }